import { RemoteData } from 'app/infrastructure/remote-data/remote-data';
import { FavouriteDefinition, ApiResponse } from 'app/types-shared';
import { endpoint } from './constants';
import { ReportCategory } from 'app/area/favourite/types';

export type Id = number | string;

export const api = {

  reportCategory: async (): Promise<ReportCategory> => {

    const response = await new RemoteData(endpoint.reportCategory).resource<ApiResponse<any>>()
      .single();

    return response.data;
  },

  definition: async (id: string | number): Promise<FavouriteDefinition> => {

    const response = await new RemoteData(endpoint.favouriteDefinition).resource<ApiResponse<FavouriteDefinition>>()
      .withId(id)
      .single();

    return response.data;
  },

  createDraftDefinition: async (id: string | number): Promise<FavouriteDefinition> => {

    const response = await new RemoteData(endpoint.favouriteDefinition)
      .resource<any>()
      .filter({ favouriteId: id })
      .create(undefined, false);

    const json = await response.json();

    return json.data;
  },

  createSearchDefinition: async (queryParameters?: {[key:string]: string | number}): Promise<number> => {

    const response = await new RemoteData(endpoint.searchFavouriteDefinition)
      .resource<any>()
      .filter({
        ...queryParameters
      })
      .create(undefined, false);

    const json = await response.json();

    return json.data;
  },

  createCompanyReportDefinition: async (
    companyReportId: Id, 
    queryParameters?: {[key:string]: string | number}
    ): Promise<number> => {
    const response = await new RemoteData(endpoint.specialReportFavouriteDefinition)
      .resource<any>()
      .filter({
        companyReportId,
        ...queryParameters
      })
      .create(undefined, false);

    const json = await response.json();

    return json.data;
  },

  saveFavouriteDefinition: async (definition: FavouriteDefinition) => {
    const response = await new RemoteData(endpoint.favouriteDefinition)
      .resource<{json:{data:FavouriteDefinition; message:any}}>()
      .withId(definition.favourite.v)
      .save(definition);
    return response.json?.data;
  },

  sortOptions: async (id: number, favourite: number, query?: string): Promise<any> => {

    const response = await new RemoteData(!query ? endpoint.favouriteReportSortOptions :
      `${endpoint.favouriteReportSortOptions}/search`).resource<ApiResponse<any>>()
      .filter({ id, favourite, query })
      .single();

    return response.data;
  },

  downloadReport: async (definition: FavouriteDefinition): Promise<any> => {
    const response = await new RemoteData(endpoint.downloadReportToExcel).resource<ApiResponse<any>>().create(definition, false);
    return await response;
  },

  multipleSuppliersUrl: async (): Promise<string> => {
    const response = await new RemoteData(endpoint.getExternalUrl(2)).resource<ApiResponse<{ urlTemplate: string }>>().single();    
    
    return response.data.urlTemplate;
  },  
  
  searchRequiredUsers: async (): Promise<boolean> => {
    const response = await new RemoteData(endpoint.loadUsersMetadata).resource<ApiResponse<{ searchRequired: boolean }>>().single();   
    
    return response.data.searchRequired;
  }
};
